import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// @ts-ignore
// tslint:disable-next-line:no-submodule-imports
import merge from 'lodash/merge';
import DOM from "../../utils/dom";
import { Event } from "./event";

var MapMouseEvent = /*#__PURE__*/function (_Event) {
  _inherits(MapMouseEvent, _Event);

  var _super = _createSuper(MapMouseEvent);

  /**
   * `true` if `preventDefault` has been called.
   * @private
   */

  /**
   * The `Map` object that fired the event.
   */

  /**
   * The DOM event which caused the map event.
   */

  /**
   * The pixel coordinates of the mouse cursor, relative to the map and measured from the top left corner.
   */

  /**
   * The geographic location on the map of the mouse cursor.
   */

  /**
   * @private
   */
  function MapMouseEvent(type, map, originalEvent) {
    var _this;

    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, MapMouseEvent);

    var point = DOM.mousePos(map.getCanvasContainer(), originalEvent);
    var lngLat = map.unproject(point);
    _this = _super.call(this, type, merge({
      point: point,
      lngLat: lngLat,
      originalEvent: originalEvent
    }, data));
    _this.defaultPrevented = false;
    _this.target = map;
    return _this;
  }

  _createClass(MapMouseEvent, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = true;
    }
  }]);

  return MapMouseEvent;
}(Event);

export { MapMouseEvent as default };